<script setup lang="ts">
import {useStore} from '../store';
import GalleryThumbnail from './GalleryThumbnail.vue';

const store = useStore();
</script>

<template>
    <div class="gallery-thumbs">
        <GalleryThumbnail
            :key="index"
            :index="index"
            :image="image"
            v-for="(image, index) in store.images"
        />
    </div>
</template>
